import Box from '@mui/material/Box';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';

import { periodRangeLabel, periodTick } from '../format';

interface YearSliderProps {
  years: number[];
  year: number;
  onChange: (year: number) => void;
}

export default function YearSlider({ years, year, onChange }: YearSliderProps) {
  const single = years.length < 2;

  return (
    <Box>
      <Typography
        variant="overline"
        sx={{
          color: 'text.secondary',
          letterSpacing: '0.08em',
          fontWeight: 700,
          display: 'block',
        }}
      >
        Estimate period
      </Typography>

      <Typography variant="h2" sx={{ mb: single ? 0 : 0.25, fontVariantNumeric: 'tabular-nums' }}>
        {periodRangeLabel(year)}
      </Typography>

      {!single && (
        <Box sx={{ px: 0.75 }}>
          <Slider
            size="small"
            value={year}
            min={years[0]}
            max={years[years.length - 1]}
            step={null}
            marks={years.map((y) => ({ value: y, label: periodTick(y) }))}
            valueLabelDisplay="off"
            aria-label="Estimate period"
            getAriaValueText={(value) => periodRangeLabel(value)}
            onChange={(_, next) => {
              if (typeof next === 'number' && next !== year) onChange(next);
            }}
            sx={{
              mt: 0.5,
              '& .MuiSlider-markLabel': {
                fontSize: '0.7rem',
                fontVariantNumeric: 'tabular-nums',
              },
              '& .MuiSlider-mark': { height: 6, width: 1.5, opacity: 0.5 },
              '& .MuiSlider-thumb': { width: 14, height: 14 },
              '& .MuiSlider-rail': { opacity: 0.28 },
            }}
          />
        </Box>
      )}
    </Box>
  );
}
